<div class="container mt-4 mb-5">
    <div class="d-flex justify-content-between  align-items-center card-header">
        <h4 class="card-title text-left mt-3 mb-3  text-brand-purple ">{{isEdit() ? 'Edit Profile' :'My Profile'}}</h4>
        <div>
            @if (!isEdit()) {
            <button class="btn bg-snow-white rounded-12 px-3 py-2" (click)="showEditForm()">
                <img src="assets/icons/fa-edit.svg" alt="edit-icon" class="align-text-top" width="16" height="16">
                <span class="ms-2 fw-medium text-secondary-grey"> Edit</span>
            </button>
            }
        </div>
    </div>
    <div class="card border-0 rounded-12">
        <div class="cover-image-section position-relative">
                <app-image-upload 
                [defaultimage]="'assets/images/default-cover.png'" 
                (fileSelected)="uploadProfileImage($event , 'cover_photo')"
                (imageRemoved)="removeImage('cover_photo')"
                [wrapperClass]="'cover-image'"
                [showPreviewOnSelect]="false" 
                [buttonClass]="'btn-light-snow-white'"
                [imageUrl]="user()?.cover_photo_url"
                [loading]="coverLoader()"
                [isShowDropDown]="true"
                [buttonText]="'Cover'"
                ></app-image-upload>
        </div>
        <div class="user-image-section px-4 py-3">
            <app-image-upload 
                [defaultimage]="'assets/images/default-user.svg'" 
                [helperText]="'At least 800x800 px recommended.<br>JPG or PNG is allowed (<b>Max Size 2MB</b>)'"
                (fileSelected)="uploadProfileImage($event , 'photo')"
                (imageRemoved)="removeImage('photo')"
                [wrapperClass]="'profile-image'"
                [buttonClass]="'btn-light-gray'"
                [showPreviewOnSelect]="false" 
                [imageUrl]="user()?.photo_url"
                [loading]="profileLoader()"
                [isShowDropDown]="true"
                [buttonText]="'Image'"
                ></app-image-upload>
        </div>
    </div>
    <div>
        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
            <div class="card mt-3 p-4 border-0 rounded-12">
                <div class="row align-items-center" [class.edit-mode]="isEdit()">
                    <div class="col-md-5 spacing">
                        <label class="fs-14 text-brand-purple" id="fullName">Full Name@if (isEdit()) {<span class="text-brand-warning">*</span>}</label>
                    </div>
                    <div class="col-md-7 spacing">
                        @if (isEdit()) {
                        <input type="text" name="text" id="fullName"
                            class="form-control shadow-none rounded-12 fs-14 border border-cool-gray"
                            formControlName='fullName'>
                        } @else {
                        <h5 class="fs-14 text-secondary-grey">{{fullName()}}</h5>
                        }
                    </div>
                    <div class="col-md-5 spacing">
                        <label class="fs-14 text-brand-purple" [class.disabled]="isEdit()">Email</label>
                    </div>
                    <div class="col-md-7 spacing">
                        @if (isEdit()) {
                        <input type="text" name="text" id="email"
                            class="form-control shadow-none rounded-12 fs-14 border border-cool-gray"
                            [value]="user()?.email" disabled>
                        } @else {
                        <h5 class="fs-14 text-secondary-grey">{{user()?.email ?? '-'}}</h5>
                        }
                    </div>
                    <div class="col-md-5 spacing">
                        <label class="fs-14 text-brand-purple">Contact Number</label>
                    </div>
                    <div class="col-md-7 spacing">
                        @if (isEdit()) {
                        <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                            [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                            [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                            [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.Pakistan" [maxLength]="15"
                            [phoneValidation]="true" [separateDialCode]="separateDialCode"
                            [numberFormat]="PhoneNumberFormat.National" name="phone"
                            formControlName='contactNumber'>
                        </ngx-intl-tel-input>
                        @if (phoneControl?.touched && phoneControl?.invalid) {
                        <div>
                            @if (phoneControl?.errors?.['validatePhoneNumber']) {
                            <span class="small text-brand-warning">Invalid phone number for
                                selected country.</span>
                            }
                        </div>
                        }
                        } @else {
                        <h5 class="fs-14 text-secondary-grey">{{user()?.phone_number ?? '-'}}</h5>
                        }
                    </div>
                    <div class="col-md-5 spacing">
                        <label class="fs-14 text-brand-purple" id="designation">Designation</label>
                    </div>
                    <div class="col-md-7 spacing">
                        @if (isEdit()) {
                        <input type="text" name="text" id="designation"
                            class="form-control shadow-none rounded-12 fs-14 border border-cool-gray"
                            formControlName='designation'>
                        } @else {
                        <h5 class="fs-14 text-secondary-grey">{{user()?.designation ?? '-'}}</h5>
                        }
                    </div>
                    <div class="col-md-5 spacing">
                        <label class="fs-14 text-brand-purple" id="department">Department</label>
                    </div>
                    <div class="col-md-7 spacing">
                        @if (isEdit()) {
                        <input type="text" name="text" id="department"
                            class="form-control shadow-none rounded-12 fs-14 border border-cool-gray"
                            formControlName='department'>
                        } @else {
                        <h5 class="fs-14 text-secondary-grey">{{user()?.department ?? '-'}}</h5>
                        }
                    </div>
                    <div class="col-md-5 mb-0">
                        <label class="fs-14 text-brand-purple">Gender</label>
                    </div>
                    <div class="col-md-7 mb-0">
                        @if (isEdit()) {
                        <ng-select class="app-dropdown doc-select" [items]="gender()" formControlName="gender"
                            placeholder="Select" bindLabel="name" bindValue="name">
                        </ng-select>
                        } @else {
                        <h5 class="fs-14 text-secondary-grey">{{(user()?.gender | titlecase) ?? '-'}}</h5>
                        }
                    </div>
                </div>
            </div>
            <div class="card mt-3 p-4 border-0 rounded-12">
                <div class="row">
                    <div class="col-md-5">
                        <label class="fs-14 mb-0 text-brand-purple">Location</label>
                    </div>
                    <div class="col-md-7">
                        @if (isEdit()) {
                        <ng-select class="app-dropdown doc-select" [items]="locations()" formControlName="location"
                            bindLabel="name" placeholder="Select" bindValue="id" (change)="onLocationChange($event)"
                            (clear)="onLocationChange(null)">
                        </ng-select>
                        } @else {
                        <h5 class="fs-14 mb-0 text-secondary-grey">{{user()?.location?.name ?? '-'}}</h5>
                        }
                    </div>
                </div>
            </div>
            <div class="card mt-3 p-4 border-0 rounded-12">
                <div class="row">
                    <div class="col-md-5 ">
                        <label class="fs-14 mb-0 text-brand-purple" id="timeZone">Time Zone</label>
                    </div>
                    <div class="col-md-7 ">
                        @if (isEdit()) {
                        <ng-select class="app-dropdown doc-select" [items]="timeZones()"
                            [loading]="timeZoneLoader()" formControlName="timeZone" placeholder="Select "
                            bindLabel="name" bindValue="id">
                        </ng-select>
                        } @else {
                        <h5 class="fs-14 mb-0 text-secondary-grey">{{ timeZoneLabel() }}</h5>
                        }
                    </div>
                </div>
            </div>
            @if (isEdit()) {
            <div class=" d-flex justify-content-end gap-2 mt-2 card-buttons">
                <button type="button" class="btn border-brand-purple app-button  fs-14 rounded-12"
                    (click)="onCancelClick()">
                    Cancel
                </button>
                <button type="submit" class="btn bg-brand-purple app-button  text-white  fs-14 rounded-12"
                    [disabled]="utility.hasEmptyFields(profileForm)">
                    <app-spinner [loader]="isLoading()"></app-spinner>
                    @if (!isLoading()) {
                    <span> Update </span>
                    }
                </button>
            </div>
            }
        </form>
    </div>
</div>
